export const GOVUK = "govuk";
export const MUI = "mui";
export const ANT = "ant";

export const settings = {
  UI: MUI,
};

export const transactionCurrencyBWP = "A4485F39-32DD-EC11-BB3E-002248439013";
